import { BASE_URL } from "./variables";

export const savePatientContact = async (contactData) => {
  try {
    console.log('savePatientContact: payload=', contactData);
    
    // Use business auth token if available, otherwise use default token
    const businessToken = localStorage.getItem('businessAuthToken');
    const authToken = businessToken || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImJ1c2luZXNzSWQiOjEsIk1lbWJlcklEIjoxLCJ1c2VybmFtZSI6ImFkbWluIiwiZmlyc3ROYW1lIjoiQWRtaW5pc3RyYXRvciIsImxhc3ROYW1lIjoiQW5rb3RhIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.AxVVChn_pG_7u8Btwjn_4TMiIu22Tvf9cSIqQKGHeOU';
    
    const res = await fetch(`${BASE_URL}/save-patient-contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify(contactData)
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      console.error(`savePatientContact: HTTP ${res.status}`, text);
      throw new Error(`savePatientContact failed: ${res.status}`);
    } 

    const data = await res.json().catch(() => null);
    console.log('savePatientContact: response=', data);
    return data;
  } catch (error) {
    console.error('Error in savePatientContact:', error);
    throw error;
  }
};

export default savePatientContact;
